// extracted by mini-css-extract-plugin
export default {"readonlyValue":"employee-form-fields_readonlyValue__rAwKS","fieldHint":"employee-form-fields_fieldHint__yj1AV"};